export enum WorksheetStatus {
  Nuovo = 'Nuovo',
  Confermato = 'Confermato',
  PresaInCarico = 'PresoInCarico',
}

export interface WorksheetSearchObject {
  dataDa?: string | null;
  dataA?: string | null;
  statiBrogliaccio: WorksheetStatus[];
  soloAssociabili?: boolean | null;
}

export interface WorksheetSearch {
  searchObject: WorksheetSearchObject;
}

export interface Worksheet {
  id: string;
  numeroBrogliaccio: number;
  data: string;
  statoBrogliaccio: WorksheetStatus;
  nomeUtente?: string | null;
  totaleValuta?: number | null;
  totaleAssegni?: number | null;
  totale?: number | null;
  numeroIncassi: number;
}

export interface WorksheetList {
  items: Worksheet[];
  totalItems: number;
}

export interface WorksheetPayment {
  numeroIncasso?: number | null;
  dataIncasso?: string | null;
  ragioneSocialeCliente?: string | null;
  monete?: number | null;
  banconote?: number | null;
  totale?: number | null;
}

export interface WorksheetCheck {
  numeroIncasso?: number | null;
  dataIncasso?: string | null;
  ragioneSocialeCliente?: string | null;
  abi?: string | null;
  cab?: string | null;
  nomeBanca?: string | null;
  numeroAssegno?: string | null;
  importo?: number | null;
}

export interface WorksheetTransaction {
  numeroDocumento?: string | null;
  dataDocumento?: string | null;
  dataScadenza?: string | null;
  totaleFattura?: number | null;
  importoAssegnato?: number | null;
  importoResiduo?: number | null;
  numeroIncasso?: number | null;
}

export interface WorksheetAdvance {
  codiceClienteErp?: string | null;
  ragioneSociale?: string | null;
  partitaIva?: string | null;
  importo?: number | null;
  numeroIncasso?: number | null;
}

export interface WorksheetDetail {
  id?: string | null;
  numeroBrogliaccio: number;
  statoBrogliaccio: WorksheetStatus;
  versamentiContante: WorksheetPayment[];
  assegni: WorksheetCheck[];
  partiteAssociate: WorksheetTransaction[];
  acconti: WorksheetAdvance[];
  totaleValuta?: number | null;
  totaleAssegni?: number | null;
  totale?: number | null;
}

export interface CreateWorksheetResponse {
  idBrogliaccio: string | null;
}
